<div class="skip-navigation" role="list">
	<div role="listitem" *ngFor="let item of skip_navigation; let index = index">
		<button
			*ngIf="!item.newTab"
			(click)="TAP_gotTo(item.url)"
			class="skip-navigation--link"
			[attr.accesskey]="index"
		>{{ item.label }} [{{ index }}]</button>

		<a
			*ngIf="item.newTab"
			href="{{item.url}}"
			class="skip-navigation--link"
			[attr.accesskey]="index"
			target="_blank"
		>
			{{ item.label }} [{{ index }}]
			<span class="visuallyhidden"
				>The link opens in a new Window</span
			>
		</a>
	</div>
</div>
